<template>
  <div>
    <div>
      <div>
        <!-- /End replace -->
      </div>
      <div class="container">
        <div
          class="row justify-content-center mt-3"
          style="text-align: center;"
        >
          <p class="h3">
            Gym Openning Clock In
          </p>
        </div>
        <div
          class="row justify-content-center mt-3"
          style="text-align: center;"
        >
          <p class="h5">{{ getCurrentDate() }}</p>
        </div>
        <div class="text-center my-2" v-if="checkClockinLoading">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <div v-else>
          <div
            v-if="!isClockin"
            class="row justify-content-center mt-3"
            style="text-align: center;"
          >
            <b-button
              size="lg"
              variant="primary"
              @click="clockin"
              v-if="!clockinLoading"
              >เริ่มเข้างาน</b-button
            >
            <div class="text-center my-2" v-else>
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
          <div
            v-else
            class="row justify-content-center mt-3"
            style="text-align: center;"
          >
            -- เข้างานเรียบร้อยเมื่อ {{ clockinTime }} --
          </div>
          <div class="mt-3" v-show="hasMessage" style="text-align: center;">
            <b-alert variant="success" show>{{ showMessage }}</b-alert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      name: "",
      isClockin: false,
      clockinLoading: false,
      checkClockinLoading: true,
      clockinTime: null,
      hasMessage: false,
      showMessage: null,
    };
  },
  mounted() {
    this.checkclockin();
  },
  created() {},
  computed: {
    ...mapState({
      user: "user",
    }),
  },
  methods: {
    logout() {
      axios.post("/logout").then((response) => {
        localStorage.removeItem("isLoggedIn");
        this.$router.push({ name: "Home" });
      });
    },
    async checkclockin() {
      this.checkClockinLoading = true;
      await axios.get("/api/checkclockin").then((response) => {
        //console.log(response.data);

        if (response.data.status) {
          this.clockinTime = response.data.data;
          this.isClockin = true;
        } else {
        }
        //this.items = response.data;
        //this.totalRows = this.items.length;
        //console.log(response.data);
        this.checkClockinLoading = false;
      });
    },
    async clockin() {
      this.hasMessage = false;
      this.showMessage = "";

      this.clockinLoading = true;
      await axios
        .post("/api/clockin", {
          date: moment().format("DD/MM/YYYY hh:mm"),
        })
        .then((response) => {
          //console.log(response.data);

          if (response.data.status == "SUCCESS") {
            this.clockinTime = response.data.data;
            this.isClockin = true;
            //this.hasMessage = true;
            //this.showMessage = "Clocked In at " + response.data.data;
          } else if (response.data.status == "EXISTS") {
            //console.log("xx");
            //this.hasMessage = true;
            //this.showMessage = "Already Clock In at " + response.data.data;
          } else {
            this.hasMessage = true;
            this.showMessage = "ERROR OCCURS";
          }
          //this.items = response.data;
          //this.totalRows = this.items.length;
          //console.log(response.data);
          this.clockinLoading = false;
        });
    },
    getCurrentDate() {
      return moment().format("DD/MM/YYYY");
    },
  },
};
</script>
